/* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-25) — Unlinked-email review queue UI.
   Admin-only toolbar button + modal over the worker's unlinked-email endpoints:
     GET  /admin/unlinked-emails          — the review queue
     POST /admin/unlinked-email-assign    — link a message (+ thread) to a deal
     POST /admin/unlinked-email-dismiss   — drop a message from the queue
     GET  /admin/unlinked-email-audit     — retroactive, report-only system sweep
   Inbound customer emails the live sync couldn't auto-place land here instead of
   ⛔ IT NOW HOLDS TWO QUEUES, ON PURPOSE (Ryan 2026-08-20). ECORE's sample shipment
   notifications that the inbound scraper would not place park here too:
     GET  /admin/sample-replies?scan=1   — the queue (scan=1 reads Abby's mailbox now)
     POST /admin/sample-reply-assign     — record the tracking number on a deal
     POST /admin/sample-reply-dismiss    — drop it
   Ryan asked for one place rather than a second button: two review queues in two places is
   how one of them stops being read. The red count is the sum of both, so the badge means
   "something here needs you" whichever kind it is.
   vanishing silently. Self-contained: self-bootstraps off window.RepPortal,
   reuses the shared modal classes, no dashboard-main.js wiring. */
(function () {
  'use strict';
  window.RQD = window.RQD || {};

  function esc(s) { var d = document.createElement('div'); d.textContent = String(s == null ? '' : s); return d.innerHTML; }
  function fmtDate(s) {
    if (!s) return '';
    try { var d = new Date(s); if (isNaN(d.getTime())) return String(s).slice(0, 10); return d.toLocaleDateString(); }
    catch (e) { return String(s).slice(0, 10); }
  }

  // Wait for the portal session before deciding whether to show the button.
  function ready(cb) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (window.RepPortal && window.RepPortal.Auth && window.RepPortal.API) {
        var sess = null;
        try { sess = window.RepPortal.Auth.getSession(); } catch (e) { /* */ }
        if (sess) { clearInterval(t); cb(sess); return; }
      }
      if (tries > 100) clearInterval(t); // ~20s cap — non-admin / logged-out: never fires
    }, 200);
  }

  ready(function (sess) {
    var isAdmin = !!(sess && (sess.admin === true || sess.role === 'admin'));
    if (!isAdmin) return;
    injectButton(window.RepPortal.API);
  });

  function injectButton(API) {
    if (document.getElementById('rqd-unlinked-btn')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'rqd-unlinked-btn';
    btn.title = 'Inbound customer emails the sync could not auto-match to a deal, plus ECORE sample replies the scraper would not place — review/assign, plus email trace, ghost-sweep, lead-CC check, and SA re-freeze';
    btn.addEventListener('click', function () { openModal(API, btn); });

    // Tuck it next to "+ New" as a small, muted text link with a "|" divider — it
    // only draws the eye when the red count badge lights up (a real unlinked email).
    var newWrap = document.getElementById('rqd-new-wrap');
    if (newWrap && newWrap.parentNode) {
      btn.className = 'rqd-pill';
      btn.style.cssText = 'white-space:nowrap;vertical-align:middle;';
      var sep = document.createElement('span');
      sep.id = 'rqd-unlinked-sep';
      sep.textContent = '|';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-29) — the look lives in dashboard.css on
         `.rqd-filter-sep, .rqd-sep`, shared with the MONEY MOVES and Refresh dividers.
         ⛔ The inline cssText that used to be here was DELETED rather than edited to match:
         an inline style outranks the stylesheet, so updating the shared rule while leaving
         this behind would have changed nothing visible and looked like a CSS bug. */
      sep.className = 'rqd-sep';
      sep.setAttribute('aria-hidden', 'true');
      var anchor = newWrap.nextSibling;
      newWrap.parentNode.insertBefore(sep, anchor);
      newWrap.parentNode.insertBefore(btn, anchor);
    } else {
      var bar = document.querySelector('.rqd-controls');
      if (!bar) return;
      btn.className = 'rqd-controls__select';
      btn.style.cssText = 'cursor:pointer;white-space:nowrap;';
      bar.appendChild(btn);
    }
    setBtnLabel(btn, null);
    refreshCount(API, btn);
  }

  function setBtnLabel(btn, n) {
    btn.innerHTML = 'Unlinked emails'
      + (n > 0 ? ' <span style="display:inline-block;min-width:16px;padding:0 5px;border-radius:9px;background:#dc2626;color:#fff;font-size:10px;font-weight:700;line-height:16px;text-align:center;vertical-align:middle;">' + n + '</span>' : '');
  }

  /* ⚠️ BOTH queues, summed. A badge that counted only one of them would sit at zero while the
     other had work in it — and this button is deliberately quiet until the number lights up, so
     an uncounted queue is an invisible one. Either request failing contributes 0 rather than
     breaking the label: a missing count must not cost the other queue its badge. */
  function refreshCount(API, btn) {
    Promise.all([
      API.get('/admin/unlinked-emails').then(function (r) { return (r && r.count) || 0; }).catch(function () { return 0; }),
      API.get('/admin/sample-replies').then(function (r) { return (r && r.count) || 0; }).catch(function () { return 0; })
    ]).then(function (counts) { setBtnLabel(btn, counts[0] + counts[1]); });
  }

  function openModal(API, btn) {
    var prior = document.getElementById('rqd-unlinked-overlay');
    if (prior) prior.remove();

    var overlay = document.createElement('div');
    overlay.id = 'rqd-unlinked-overlay';
    overlay.className = 'rqd-daterange-backdrop';
    overlay.innerHTML = [
      /* CUSTOM_UNLINKEDSCROLL_BY_CLAUDE (Ryan 2026-10-12) - the panel scrolls as a whole. It was a fixed-height flex column with no
         overflow, so once the switches above grew, the ECORE sample replies and the unlinked list were cut off with no scrollbar. */
      '<div class="rqd-daterange-modal" style="max-width:760px;padding:22px 26px;max-height:86vh;overflow-y:auto;display:block;">', /* display:block - the shared class is a flex column, which shrinks any scrolling list in here to 0 height */
      '  <h3 class="rqd-daterange-modal__title" style="margin-top:0;">Unlinked customer emails</h3>',
      '  <div style="font-size:12px;color:var(--rq-text-secondary);margin-bottom:12px;">',
      '    Inbound emails the sync couldn’t auto-match to a deal (e.g. sent from an address that isn’t on the deal). Assign one to a deal — which also teaches the deal that address so future mail auto-links — or dismiss it.',
      '  </div>',
      '  <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;flex-wrap:wrap;">',
      '    <button type="button" id="rqd-unlinked-audit-btn" class="rqd-pill">Run system-wide audit</button>',
      '    <label style="font-size:11px;color:var(--rq-text-secondary);">last <input type="number" id="rqd-unlinked-audit-days" value="30" min="1" max="90" style="width:52px;padding:3px 5px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;text-align:right;background:var(--rq-bg-input);color:var(--rq-text);"> days (report-only)</label>',
      '    <span id="rqd-unlinked-audit-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      '  <div id="rqd-unlinked-audit-report" style="display:none;font-size:12px;border:1px solid var(--rq-border);border-radius:6px;padding:10px 12px;margin-bottom:12px;background:var(--rq-bg-input);max-height:42vh;overflow-y:auto;"></div>',
      '  <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:wrap;">',
      '    <button type="button" id="rqd-ghost-btn" class="rqd-pill">Sweep mailboxes for ghost-linked emails</button>',
      '    <label style="font-size:11px;color:var(--rq-text-secondary);">from <input type="number" id="rqd-ghost-days" value="120" min="1" max="365" style="width:56px;padding:3px 5px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;text-align:right;background:var(--rq-bg-input);color:var(--rq-text);"> to <input type="number" id="rqd-ghost-until" value="0" min="0" max="364" style="width:48px;padding:3px 5px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;text-align:right;background:var(--rq-bg-input);color:var(--rq-text);"> days ago (report-only)</label>',
      '    <span id="rqd-ghost-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      '  <div id="rqd-ghost-report" style="display:none;font-size:12px;border:1px solid var(--rq-border);border-radius:6px;padding:10px 12px;margin-bottom:12px;background:var(--rq-bg-input);max-height:42vh;overflow-y:auto;"></div>',
      '  <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:wrap;border-top:1px dashed var(--rq-border);padding-top:10px;">',
      '    <span style="font-size:11px;font-weight:600;color:var(--rq-text-secondary);">🔍 Trace a specific email</span>',
      '    <input type="text" id="rqd-trace-q" placeholder="subject, sender, or a phrase" style="flex:1;min-width:160px;padding:5px 8px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);">',
      '    <button type="button" id="rqd-trace-btn" class="rqd-pill">Trace</button>',
      '    <span id="rqd-trace-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      '  <div id="rqd-trace-report" style="display:none;font-size:12px;border:1px solid var(--rq-border);border-radius:6px;padding:10px 12px;margin-bottom:12px;background:var(--rq-bg-input);max-height:42vh;overflow-y:auto;"></div>',
      '  <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:wrap;border-top:1px dashed var(--rq-border);padding-top:10px;">',
      '    <button type="button" id="rqd-leadcc-btn" class="rqd-pill">Check lead-email CC list</button>',
      '    <span id="rqd-leadcc-result" style="font-size:11px;color:var(--rq-text-secondary);">who gets CC\'d on new-lead notifications</span>',
      '  </div>',
      '  <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:wrap;">',
      '    <button type="button" id="rqd-refreeze-btn" class="rqd-pill">Re-freeze Sales-Analytics month</button>',
      '    <input type="text" id="rqd-refreeze-month" placeholder="YYYY-MM" maxlength="7" style="width:84px;padding:3px 6px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);">',
      '    <span id="rqd-refreeze-result" style="font-size:11px;color:var(--rq-text-secondary);">recompute a closed month after ghost repairs</span>',
      '  </div>',
      '  <div style="border-top:1px dashed var(--rq-border);padding-top:12px;margin-bottom:6px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;">',
      '    <span style="font-size:12px;font-weight:700;">📧 Abby’s automatic “samples are on the way” email</span>',
      '    <button type="button" id="rqd-autonotify-toggle" class="rqd-pill" style="font-size:11px;">…</button>',
      '    <label style="font-size:11px;color:var(--rq-text-secondary);">wait <input type="number" id="rqd-autonotify-grace" value="0" min="0" max="720" style="width:56px;padding:3px 5px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;text-align:right;background:var(--rq-bg-input);color:var(--rq-text);"> min before sending</label>',
      '    <button type="button" id="rqd-autonotify-grace-save" class="rqd-pill" style="font-size:11px;">Save</button>',
      '    <span id="rqd-autonotify-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      /* CUSTOM_SAMPLETHANKS_BY_CLAUDE (ONYX 9a031d1dd9f6, Ryan 2026-10-12) - Abby's you're-welcome when a customer only says thanks
         to that email. Same record as the switch above (`thanksReply`), its own button. */
      '  <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:wrap;">',
      '    <span style="font-size:12px;font-weight:700;">🙏 Abby’s “you’re welcome” when a customer only says thanks to it</span>',
      '    <button type="button" id="rqd-thanks-toggle" class="rqd-pill" style="font-size:11px;">…</button>',
      '    <span id="rqd-thanks-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      /* CUSTOM_SAMPLESERVICE_BY_CLAUDE (ONYX be1e5da9efa9, Ryan 2026-10-14) - when samples were asked to go FedEx Priority
         Overnight and FedEx shows a Ground label not yet picked up, Abby asks the samples desk to switch it. Same record
         (`serviceAsk`), its own button, ships OFF. */
      '  <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:wrap;">',
      '    <span style="font-size:12px;font-weight:700;">🚀 Abby asks ECORE to switch a Ground label to Priority Overnight when that was asked</span>',
      '    <button type="button" id="rqd-svcask-toggle" class="rqd-pill" style="font-size:11px;">…</button>',
      '    <span id="rqd-svcask-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      '  <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;flex-wrap:wrap;">',
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — ⛔ ONE CONTROL BECAME TWO, SPLIT ON WHOSE
         MAILBOX SENDS. Ryan, after the first live run: *"I definitely still want reps customers
         to get emails from Abbey with tracking emails... What I am gating from reps is once the
         sample is delivered, the automatic follow-up that comes from the reps actual email."*

         ⚠️ EACH SWITCH NOW SITS UNDER THE THING IT MOVES. The single control sat below both
         panels and read as though it governed the page, which is how it came to claim "all three
         flows" and still be misread. This one is indented under the notice's own on/off switch;
         the rep-mailbox senders get their own headed block below. */
      '    <span style="font-size:11px;color:var(--rq-text-secondary);">└ this notice runs for</span>',
      '    <select id="rqd-notice-audience-select" style="padding:3px 6px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);">',
      '      <option value="admins">admin-owned deals only</option>',
      '      <option value="everyone">every rep’s deals</option>',
      '    </select>',
      '    <span id="rqd-notice-audience-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      '  <div style="font-size:11px;color:var(--rq-text-secondary);margin-bottom:12px;">When a sample tracking number is recorded, Abby emails the customer inside the 6am–6pm MT window, <strong>copying the rep who owns the deal</strong>. <strong>This sends real customer email with nobody watching.</strong> Turning it off also holds anything already queued. Individual deals can be stopped from their own card.</div>',
      '  <div style="border-top:1px dashed var(--rq-border);padding-top:12px;margin-bottom:6px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;">',
      '    <span style="font-size:12px;font-weight:700;">✉️ Automated emails sent from a rep’s OWN mailbox</span>',
      '  </div>',
      '  <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;flex-wrap:wrap;padding-left:14px;">',
      '    <span style="font-size:11px;color:var(--rq-text-secondary);">└ these run for</span>',
      '    <select id="rqd-audience-select" style="padding:3px 6px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);">',
      '      <option value="admins">admin-owned deals only</option>',
      '      <option value="everyone">every rep\u2019s deals</option>',
      '    </select>',
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — ⛔ THE LABEL COUNTS WHAT THIS SWITCH MOVES, AND THE COUNT
         WENT DOWN (2026-08-25). It read "covers all three automated flows" while three flows
         shared one key; Abby's notice left for its own control above, so this one moves TWO.
         ⚠️ An OVERSTATED label invites the same wrong flip an understated one does — somebody
         reads it, believes the notice is still in here, and narrows this expecting to stop it.
         Re-count it whenever a flow joins or leaves `deal-automation-audience`.

         The original note, which is why the count is written down at all (2026-08-20):
         ⛔ THIS SWITCH MOVES THREE FLOWS, NOT TWO.
         It read "covers the follow-up ladder too" until the composer-armed SEQUENCES shipped and
         started reading the same setting. A switch that understates its own blast radius is worse
         than one with no label at all: it invites a flip that turns on more than the person
         flipping it had in mind. Add the flow here the next time one starts reading this key. */
      '    <span id="rqd-audience-status" style="font-size:11px;color:var(--rq-text-secondary);">the samples follow-up ladder + composer sequences</span>',
      '  </div>',
      '  <div style="font-size:11px;color:var(--rq-text-secondary);margin-bottom:12px;">The follow-up ladder after a sample box is delivered, and any sequence a rep arms from the email composer. <strong>These send from the rep’s own mailbox, in their name</strong> — which is why they stay admin-only while the chain is being tested.</div>',
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — the picker's "other items" list.
         Ryan: *"adding some other products like architectural folders etc."* These are not Shopify
         products and some never will be, so they live in KV and are edited here rather than
         requiring a product record and a deploy.
         ⚠️ IN THIS PANEL, NOT A NEW SCREEN — same reason the audience switches are here: a second
         place to look is a place that stops being looked at. */
      '  <div style="border-top:1px dashed var(--rq-border);padding-top:12px;margin-bottom:6px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;">',
      '    <span style="font-size:12px;font-weight:700;">🗂️ Sample picker — other items</span>',
      '    <button type="button" id="rqd-extras-add" class="rqd-pill" style="font-size:11px;">+ Add</button>',
      '    <button type="button" id="rqd-extras-save" class="rqd-pill" style="font-size:11px;">Save</button>',
      '    <span id="rqd-extras-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      '  <div style="font-size:11px;color:var(--rq-text-secondary);margin-bottom:8px;">Non-ECORE things an admin can add to a sample box — architectural folders, binders, spec sheets. Flooring samples come from Shopify (the <code>sample-eligible</code> tag) and are not listed here. <strong>Retire</strong> hides an item from the picker without removing it from deals that already list it.</div>',
      '  <div id="rqd-extras-list" style="margin-bottom:14px;"></div>',
      '  <div style="border-top:1px dashed var(--rq-border);padding-top:12px;margin-bottom:6px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;">',
      '    <span style="font-size:12px;font-weight:700;">📦 ECORE sample replies</span>',
      '    <button type="button" id="rqd-ecore-scan-btn" class="rqd-pill" style="font-size:11px;">Check Abby’s inbox now</button>',
      '    <span id="rqd-ecore-scan-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      '  <div style="font-size:11px;color:var(--rq-text-secondary);margin-bottom:8px;">Shipment notifications whose tracking number could not be matched to a deal with confidence. <strong>Nothing here has been written to any deal.</strong> Confirm the deal and the number, or dismiss it.</div>',
      '  <div id="rqd-ecore-list" style="overflow-y:auto;max-height:34vh;min-height:60px;margin-bottom:14px;">Loading…</div>',
      '  <div style="border-top:1px dashed var(--rq-border);padding-top:12px;margin-bottom:6px;font-size:12px;font-weight:700;">✉️ Unlinked customer emails</div>',
      '  <div id="rqd-unlinked-list" style="overflow-y:auto;max-height:40vh;min-height:80px;">Loading…</div>',
      '  <div class="rqd-daterange-modal__footer" style="margin-top:14px;">',
      '    <button type="button" id="rqd-unlinked-close" class="rqd-pill" style="margin-right:auto;">Close</button>',
      '  </div>',
      '</div>',
    ].join('\n');

    var mount = document.querySelector('.rep-quote-portal-wrap') || document.body;
    mount.appendChild(overlay);

    function close() { overlay.remove(); refreshCount(API, btn); }
    overlay.querySelector('#rqd-unlinked-close').addEventListener('click', close);
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
    overlay.addEventListener('click', function (e) { if (window.RepPortal.dismissedOnBackdrop(e, overlay)) close(); });

    var listEl = overlay.querySelector('#rqd-unlinked-list');

    function rowHtml(it) {
      var who = (it.fromName ? esc(it.fromName) + ' ' : '') + '&lt;' + esc(it.from) + '&gt;';
      return '<div class="rqd-unlinked-row" data-mid="' + esc(it.messageId) + '" style="border:1px solid var(--rq-border);border-radius:6px;padding:8px 10px;margin-bottom:8px;">'
        + '<div style="display:flex;justify-content:space-between;gap:8px;align-items:baseline;">'
        + '<span style="font-weight:600;font-size:12px;">' + who + '</span>'
        + '<span style="font-size:11px;color:var(--rq-text-secondary);white-space:nowrap;">' + esc(fmtDate(it.receivedDateTime)) + '</span>'
        + '</div>'
        + '<div style="font-size:12px;margin:2px 0;">' + (it.subject ? esc(it.subject) : '<em style="color:var(--rq-text-secondary);">(no subject)</em>') + '</div>'
        + (it.preview ? '<div style="font-size:11px;color:var(--rq-text-secondary);margin-bottom:6px;">' + esc(it.preview) + '</div>' : '')
        + '<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;">'
        + '<input type="text" class="rqd-unlinked-ref" placeholder="Deal ref (e.g. JW-1196-A)" style="flex:1;min-width:150px;padding:5px 8px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);text-transform:uppercase;">'
        + '<button type="button" class="rqd-unlinked-assign rqd-pill rqd-pill--active" style="font-size:11px;">Assign to deal</button>'
        + '<button type="button" class="rqd-unlinked-dismiss rqd-pill" style="font-size:11px;" title="Not deal-related — remove from the queue">Dismiss</button>'
        + '<span class="rqd-unlinked-row-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>'
        + '</div>'
        + '</div>';
    }

    function loadList() {
      listEl.textContent = 'Loading…';
      API.get('/admin/unlinked-emails').then(function (res) {
        var items = (res && res.emails) || [];
        if (!items.length) {
          listEl.innerHTML = '<div style="padding:14px 4px;font-size:12px;color:var(--rq-text-secondary);">No unlinked emails in the queue. 🎉 New ones appear here automatically when the sync can’t place an inbound email. Use the audit above to scan history.</div>';
          return;
        }
        listEl.innerHTML = items.map(rowHtml).join('');
      }).catch(function (err) {
        listEl.innerHTML = '<div style="padding:14px 4px;font-size:12px;color:#dc2626;">Could not load the queue: ' + esc((err && err.message) || 'error') + '</div>';
      });
    }

    // Row actions (delegated).
    listEl.addEventListener('click', function (e) {
      var row = e.target.closest('.rqd-unlinked-row');
      if (!row) return;
      var mid = row.getAttribute('data-mid');
      var statusEl = row.querySelector('.rqd-unlinked-row-status');

      if (e.target.closest('.rqd-unlinked-assign')) {
        var refInput = row.querySelector('.rqd-unlinked-ref');
        var ref = String((refInput && refInput.value) || '').trim().toUpperCase();
        if (!ref) { statusEl.textContent = 'Enter a deal ref first.'; statusEl.style.color = '#dc2626'; return; }
        var aBtn = e.target.closest('.rqd-unlinked-assign');
        aBtn.disabled = true; statusEl.style.color = 'var(--rq-text-secondary)'; statusEl.textContent = 'Assigning…';
        API.post('/admin/unlinked-email-assign', { messageId: mid, ref: ref }).then(function (res) {
          if (!res || res.success === false || res.error) throw new Error((res && res.error) || 'Assign failed');
          row.style.transition = 'opacity .2s'; row.style.opacity = '0.5';
          var bits = [];
          if (res.linked) bits.push('linked ' + res.linked);
          if (res.swept) bits.push('+' + res.swept + ' from thread');
          if (res.emailAdded) bits.push('address added to deal');
          statusEl.style.color = '#15803d';
          statusEl.textContent = '✓ ' + ref + (bits.length ? ' (' + bits.join(', ') + ')' : '');
          setTimeout(function () { row.remove(); if (!listEl.querySelector('.rqd-unlinked-row')) loadList(); }, 1200);
        }).catch(function (err) {
          aBtn.disabled = false; statusEl.style.color = '#dc2626';
          statusEl.textContent = (err && err.message) || 'Assign failed';
        });
        return;
      }

      if (e.target.closest('.rqd-unlinked-dismiss')) {
        var dBtn = e.target.closest('.rqd-unlinked-dismiss');
        dBtn.disabled = true; statusEl.style.color = 'var(--rq-text-secondary)'; statusEl.textContent = 'Dismissing…';
        API.post('/admin/unlinked-email-dismiss', { messageId: mid }).then(function (res) {
          if (!res || res.success === false || res.error) throw new Error((res && res.error) || 'Dismiss failed');
          row.remove(); if (!listEl.querySelector('.rqd-unlinked-row')) loadList();
        }).catch(function (err) {
          dBtn.disabled = false; statusEl.style.color = '#dc2626';
          statusEl.textContent = (err && err.message) || 'Dismiss failed';
        });
        return;
      }
    });

    // Retroactive report-only audit.
    var auditBtn = overlay.querySelector('#rqd-unlinked-audit-btn');
    var auditStatus = overlay.querySelector('#rqd-unlinked-audit-status');
    var auditReport = overlay.querySelector('#rqd-unlinked-audit-report');
    auditBtn.addEventListener('click', function () {
      var days = parseInt((overlay.querySelector('#rqd-unlinked-audit-days') || {}).value, 10) || 30;
      auditBtn.disabled = true; auditStatus.textContent = 'Scanning mailboxes… (can take a minute)';
      API.get('/admin/unlinked-email-audit?days=' + days).then(function (res) {
        auditBtn.disabled = false; auditStatus.textContent = '';
        if (!res || res.success === false) throw new Error((res && res.error) || 'Audit failed');
        var t = res.totals || {};
        var perRep = (res.perRep || []).filter(function (r) { return r && (r.inboundScanned || r.error); });
        var html = '<div style="font-weight:700;margin-bottom:6px;">Audit — last ' + esc(res.days) + ' days, ' + esc(res.reps) + ' mailbox(es)</div>';
        html += '<div style="margin-bottom:8px;">'
          + '<span style="color:#b45309;font-weight:700;">' + (t.missingButMatchable || 0) + '</span> inbound emails match a deal but were never linked (recoverable). '
          + '<span style="color:var(--rq-text-secondary);">' + (t.unmatchedNoise || 0) + '</span> matched no deal (noise or customer mail from an unknown address — those show in the queue below as they arrive). '
          + (t.alreadyLinked || 0) + ' already linked, ' + (t.inboundScanned || 0) + ' scanned.'
          + '</div>';
        if (perRep.length) {
          html += '<table style="width:100%;border-collapse:collapse;font-size:11px;">'
            + '<tr style="text-align:left;color:var(--rq-text-secondary);"><th style="padding:2px 4px;">Mailbox</th><th style="padding:2px 4px;">Missing</th><th style="padding:2px 4px;">Unmatched</th><th style="padding:2px 4px;">Scanned</th></tr>';
          perRep.forEach(function (r) {
            html += '<tr><td style="padding:2px 4px;">' + esc(r.repCode) + (r.error ? ' <span style="color:#dc2626;">(' + esc(r.error) + ')</span>' : '') + (r.truncated ? ' <span title="hit the page cap; older mail not scanned" style="color:#b45309;">⚠</span>' : '') + '</td>'
              + '<td style="padding:2px 4px;font-weight:700;color:#b45309;">' + (r.missingButMatchable || 0) + '</td>'
              + '<td style="padding:2px 4px;color:var(--rq-text-secondary);">' + (r.unmatchedNoise || 0) + '</td>'
              + '<td style="padding:2px 4px;">' + (r.inboundScanned || 0) + '</td></tr>';
          });
          html += '</table>';
        }
        var samples = res.missingSamples || [];
        if (samples.length) {
          html += '<div style="margin-top:8px;font-weight:600;">Sample of missing (matches a deal, not linked):</div>';
          html += samples.slice(0, 25).map(function (s) {
            return '<div style="font-size:11px;padding:3px 0;border-top:1px solid var(--rq-border);">'
              + '<strong>' + esc(s.ref) + '</strong> ← ' + esc(s.from) + ' · ' + esc(s.date) + ' · ' + esc(s.subject || '(no subject)') + '</div>';
          }).join('');
        }
        html += '<div style="margin-top:8px;font-size:11px;color:var(--rq-text-secondary);">Report-only — nothing was changed. The recoverable ones link automatically on the next sync once the deal carries the sender’s address; assign them from the queue to fix + teach the address now.</div>';
        auditReport.innerHTML = html;
        auditReport.style.display = '';
      }).catch(function (err) {
        auditBtn.disabled = false;
        auditStatus.textContent = 'Audit failed: ' + ((err && err.message) || 'error');
      });
    });

    // Bulk ghost sweep — mailbox-wide finder/repairer for clobbered (ghost-linked) emails.
    var ghostBtn = overlay.querySelector('#rqd-ghost-btn');
    var ghostStatus = overlay.querySelector('#rqd-ghost-status');
    var ghostReport = overlay.querySelector('#rqd-ghost-report');
    function runGhostSweep(fix) {
      var days = parseInt((overlay.querySelector('#rqd-ghost-days') || {}).value, 10) || 120;
      var until = parseInt((overlay.querySelector('#rqd-ghost-until') || {}).value, 10) || 0;
      ghostBtn.disabled = true; ghostStatus.textContent = fix ? 'Repairing…' : 'Scanning mailboxes… (can take a minute)';
      API.get('/admin/ghost-sweep?days=' + days + (until > 0 ? '&untilDays=' + until : '') + (fix ? '&fix=1' : '')).then(function (res) {
        ghostBtn.disabled = false; ghostStatus.textContent = '';
        if (!res || res.success === false) throw new Error((res && res.error) || 'Sweep failed');
        var t = res.totals || {};
        var perRep = (res.perRep || []).filter(function (r) { return r && (r.scanned || r.error); });
        var isRepair = res.mode === 'repair';
        var _window = (res.untilDays > 0) ? (esc(res.untilDays) + '–' + esc(res.days) + ' days ago') : ('last ' + esc(res.days) + ' days');
        var html = '<div style="font-weight:700;margin-bottom:6px;">Ghost sweep — ' + _window + ', ' + esc(res.reps) + ' mailbox(es)' + (isRepair ? ' · REPAIR' : '') + '</div>';
        html += '<div style="margin-bottom:4px;"><span style="color:' + ((t.ghosts || 0) > 0 ? '#dc2626' : '#15803d') + ';font-weight:700;">' + (t.ghosts || 0) + '</span> real ghost(s) — emails missing from their deal'
          + (isRepair ? ' · <span style="color:#15803d;font-weight:700;">' + (t.repaired || 0) + ' repaired</span>' : '') + ' · ' + (t.scanned || 0) + ' scanned.</div>';
        html += '<div style="margin-bottom:8px;font-size:11px;color:var(--rq-text-secondary);">' + (t.crossMailboxCopies || 0) + ' cross-mailbox copies skipped (already on the deal via the owner — repairing would duplicate).</div>';
        if (perRep.length) {
          html += '<table style="width:100%;border-collapse:collapse;font-size:11px;"><tr style="text-align:left;color:var(--rq-text-secondary);"><th style="padding:2px 4px;">Mailbox</th><th style="padding:2px 4px;">Ghosts</th><th style="padding:2px 4px;">Cross-copies</th>' + (isRepair ? '<th style="padding:2px 4px;">Repaired</th>' : '') + '<th style="padding:2px 4px;">Scanned</th></tr>';
          perRep.forEach(function (r) {
            html += '<tr><td style="padding:2px 4px;">' + esc(r.repCode) + (r.error ? ' <span style="color:#dc2626;">(' + esc(r.error) + ')</span>' : '') + (r.truncated ? ' <span title="hit the page cap; older mail not scanned — narrow the window or re-run" style="color:#b45309;">⚠</span>' : '') + '</td>'
              + '<td style="padding:2px 4px;font-weight:700;color:' + ((r.ghosts || 0) > 0 ? '#dc2626' : 'inherit') + ';">' + (r.ghosts || 0) + '</td>'
              + '<td style="padding:2px 4px;color:var(--rq-text-secondary);">' + (r.crossCopies || 0) + '</td>'
              + (isRepair ? '<td style="padding:2px 4px;color:#15803d;">' + (r.repaired || 0) + '</td>' : '')
              + '<td style="padding:2px 4px;">' + (r.scanned || 0) + '</td></tr>';
          });
          html += '</table>';
        }
        var samples = res.samples || [];
        if (samples.length) {
          html += '<div style="margin-top:8px;font-weight:600;">Sample of ghosts:</div>';
          html += samples.slice(0, 25).map(function (s) {
            return '<div style="font-size:11px;padding:3px 0;border-top:1px solid var(--rq-border);"><strong>' + esc(s.ref) + '</strong> · ' + esc(s.direction) + ' · ' + esc(s.from) + ' · ' + esc(s.date) + ' · ' + esc(s.subject || '(no subject)') + '</div>';
          }).join('');
        }
        if ((t.ghosts || 0) > 0 && !isRepair) html += '<div style="margin-top:8px;"><button type="button" id="rqd-ghost-fix" class="rqd-pill rqd-pill--active" style="font-size:11px;">Repair all ' + (t.ghosts || 0) + ' ghost(s) — re-link to their deals</button></div>';
        if (isRepair) html += '<div style="margin-top:8px;font-size:11px;color:var(--rq-text-secondary);">Repaired ' + (t.repaired || 0) + '. Refresh affected deals to see the recovered emails.' + (res.repairCapReached ? ' Cap hit this run — click again to continue.' : '') + '</div>';
        ghostReport.innerHTML = html; ghostReport.style.display = '';
        var gf = overlay.querySelector('#rqd-ghost-fix');
        if (gf) gf.addEventListener('click', function () { if (confirm('Re-link all ' + (t.ghosts || 0) + ' ghost-linked emails to their deals? (deduped — no double-posts)')) runGhostSweep(true); });
      }).catch(function (err) { ghostBtn.disabled = false; ghostStatus.textContent = 'Sweep failed: ' + ((err && err.message) || 'error'); });
    }
    if (ghostBtn) ghostBtn.addEventListener('click', function () { runGhostSweep(false); });

    // Trace a specific email — reveals where its link actually went (ghost detection).
    var traceBtn = overlay.querySelector('#rqd-trace-btn');
    var traceStatus = overlay.querySelector('#rqd-trace-status');
    var traceReport = overlay.querySelector('#rqd-trace-report');
    function runTrace(fix) {
      var q = String((overlay.querySelector('#rqd-trace-q') || {}).value || '').trim();
      if (!q) { traceStatus.textContent = 'Enter something to search.'; return; }
      traceBtn.disabled = true; traceStatus.textContent = fix ? 'Repairing…' : 'Tracing…';
      API.get('/admin/email-trace?q=' + encodeURIComponent(q) + (fix ? '&fix=1' : '')).then(function (res) {
        traceBtn.disabled = false; traceStatus.textContent = '';
        if (!res || res.success === false) throw new Error((res && res.error) || 'Trace failed');
        var rows = (res.results || []).filter(function (r) { return r && r.messageId; });
        var errs = (res.results || []).filter(function (r) { return r && r.error; });
        if (!rows.length) {
          traceReport.innerHTML = '<div>No messages found for “' + esc(q) + '”'
            + (errs.length ? ' <span style="color:#b45309;">(' + esc(errs.map(function (e) { return e.repCode + ': ' + e.error; }).join('; ')) + ')</span>' : '')
            + '. If it isn’t in any connected mailbox, that’s a coverage gap — a shared mailbox or the wrong account is connected.</div>';
          traceReport.style.display = ''; return;
        }
        var anyFixable = rows.some(function (r) { return r.status === 'GHOST' || r.status === 'unlinked'; });
        var fixCount = rows.filter(function (r) { return r.status === 'GHOST' || r.status === 'unlinked'; }).length;
        var html = '<div style="font-weight:700;margin-bottom:6px;">' + rows.length + ' message(s) for “' + esc(q) + '”</div>';
        // Repair action at the TOP so it's visible without scrolling the report.
        if (anyFixable && !fix) html += '<div style="margin:0 0 8px;"><button type="button" id="rqd-trace-fix" class="rqd-pill rqd-pill--active" style="font-size:11px;">Repair ' + fixCount + ' GHOST / unlinked — re-link to the matched deal</button></div>';
        if (fix) html += '<div style="margin:0 0 8px;font-size:11px;color:var(--rq-text-secondary);">Repair done — refresh the deal to see the recovered email(s).</div>';
        html += rows.map(function (r) {
          var color = r.status === 'GHOST' ? '#dc2626'
            : (r.status === 'unlinked' ? '#b45309'
              : (r.status === 'no-deal-match' ? '#6b7280' : '#15803d'));
          var label = r.status === 'GHOST' ? 'GHOST — has a “linked” flag but no entry on ' + esc(r.sentinelRef)
            : (r.status === 'unlinked' ? 'UNLINKED — matches ' + esc(r.sentinelRef || 'a deal') + ' but was never attached'
              : (r.status === 'no-deal-match' ? 'not matched to any deal (likely not deal-related mail)'
                : 'visible on ' + esc(r.sentinelRef)));
          return '<div style="padding:4px 0;border-top:1px solid var(--rq-border);">'
            + '<div><span style="color:' + color + ';font-weight:700;">' + esc(r.status) + '</span> — ' + label + '</div>'
            + '<div style="font-size:11px;color:var(--rq-text-secondary);">' + esc(r.direction) + ' · ' + esc(r.from) + ' · ' + esc(r.date) + ' · ' + esc(r.subject || '(no subject)') + '</div>'
            + (r.action ? '<div style="font-size:11px;color:#15803d;">→ ' + esc(r.action) + '</div>' : '')
            + '</div>';
        }).join('');
        traceReport.innerHTML = html; traceReport.style.display = '';
        var fb = overlay.querySelector('#rqd-trace-fix');
        if (fb) fb.addEventListener('click', function () { if (confirm('Re-link the GHOST / unlinked messages to their matched deal?')) runTrace(true); });
      }).catch(function (err) { traceBtn.disabled = false; traceStatus.textContent = 'Trace failed: ' + ((err && err.message) || 'error'); });
    }
    if (traceBtn) traceBtn.addEventListener('click', function () { runTrace(false); });
    var traceQ = overlay.querySelector('#rqd-trace-q');
    if (traceQ) traceQ.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); runTrace(false); } });

    // Self-serve check: who's currently on the admin CC for lead-notification emails.
    var leadCcBtn = overlay.querySelector('#rqd-leadcc-btn');
    var leadCcResult = overlay.querySelector('#rqd-leadcc-result');
    if (leadCcBtn) leadCcBtn.addEventListener('click', function () {
      leadCcBtn.disabled = true; leadCcResult.style.color = 'var(--rq-text-secondary)'; leadCcResult.textContent = 'Checking…';
      API.get('/admin/lead-cc-preview').then(function (res) {
        leadCcBtn.disabled = false;
        if (!res || res.success === false) throw new Error((res && res.error) || 'failed');
        var admins = res.admins || [];
        if (!admins.length) { leadCcResult.style.color = '#dc2626'; leadCcResult.textContent = 'No admins resolved (!) — that would be a problem.'; return; }
        leadCcResult.style.color = 'var(--rq-text-secondary)';
        leadCcResult.textContent = 'CC: ' + admins.map(function (a) { return (a.code || '?') + ' <' + a.email + '>'; }).join(', ');
      }).catch(function (err) { leadCcBtn.disabled = false; leadCcResult.style.color = '#dc2626'; leadCcResult.textContent = 'Check failed: ' + ((err && err.message) || 'error'); });
    });

    // Re-freeze a closed Sales-Analytics month after ghost repairs (effort/activity
    // counts in frozen snapshots undercounted the missing emails; sales numbers were fine).
    var refreezeBtn = overlay.querySelector('#rqd-refreeze-btn');
    var refreezeMonth = overlay.querySelector('#rqd-refreeze-month');
    var refreezeResult = overlay.querySelector('#rqd-refreeze-result');
    if (refreezeBtn) refreezeBtn.addEventListener('click', function () {
      var m = String((refreezeMonth || {}).value || '').trim();
      if (!/^\d{4}-\d{2}$/.test(m)) { refreezeResult.style.color = '#dc2626'; refreezeResult.textContent = 'Enter a month as YYYY-MM (e.g. 2026-05).'; return; }
      if (!confirm('Re-freeze the Sales-Analytics snapshot for ' + m + '?\n\nThis recomputes that closed month from the current (repaired) records — run it only AFTER the ghost cleanup is done.')) return;
      refreezeBtn.disabled = true; refreezeResult.style.color = 'var(--rq-text-secondary)'; refreezeResult.textContent = 'Recomputing ' + m + '…';
      API.post('/admin/analytics-snapshot-now?month=' + encodeURIComponent(m) + '&force=1', {}).then(function (res) {
        refreezeBtn.disabled = false;
        if (!res || res.success === false || res.error) throw new Error((res && res.error) || 'failed');
        refreezeResult.style.color = '#15803d';
        refreezeResult.textContent = '✓ Re-froze ' + m + (res.complete === false ? ' (partial month — flagged)' : '') + '.';
      }).catch(function (err) { refreezeBtn.disabled = false; refreezeResult.style.color = '#dc2626'; refreezeResult.textContent = 'Failed: ' + ((err && err.message) || 'error'); });
    });

    /* ============================================
       THE ECORE SAMPLE-REPLY QUEUE
       ============================================
       CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20)

       ⛔ EVERY ROW HERE IS A TRACKING NUMBER THAT WAS DELIBERATELY NOT WRITTEN. The scraper
       refuses rather than guesses, because the next step of the chain emails that number to a
       customer — a wrong match tells Mrs A her samples are at Mr B's house. So this queue is the
       other half of that decision: refusing is only safe if somebody can see what was refused.

       ⚠️ THE ROW SHOWS WHAT THE PARSER READ, not merely that it failed. A row saying only
       "couldn't match" makes an admin open the email to learn anything at all, and a queue that
       costs a click per row to understand is a queue that gets dismissed wholesale. */
    var ecoreListEl = overlay.querySelector('#rqd-ecore-list');

    /* One sentence per reason, in the words a person would use. ⚠️ An unknown reason falls
       through to the raw code rather than to a friendly guess — a new refusal reason showing up
       as its own string is a prompt to write it a sentence, where a generic "couldn't match"
       would hide that a new failure mode exists at all. */
    var ECORE_REASONS = {
      'no-open-requests': 'Nothing is waiting on a sample box right now, so there was no request to match this against.',
      'no-open-request-matches': 'The Project Name on this email doesn’t match any deal we’re waiting on samples for.',
      'no-project-name': 'This email carried no Project Name field, which is the only thing on it that names a deal.',
      'ambiguous-name': 'More than one open sample request is under that customer name — pick the right deal.',
      'ambiguous-ref': 'More than one open sample request matches that reference — pick the right deal.',
      'multiple-tracking-numbers': 'This email carries more than one tracking number, so which box belongs to this deal is a guess.',
      'no-tracking-number': 'No tracking number could be found in this email.',
      'tracking-number-unreadable': 'The tracking number in this email isn’t a length FedEx uses — it looks truncated.',
      'conflicting-fields': 'A field appeared twice with two different values, so which one is live is unclear.',
      'deal-already-has-a-different-number': 'That deal already has a different tracking number saved, and a person put it there.',
      'fedex-names-a-different-order': 'FedEx says this tracking number belongs to a different ECORE order.',
      'not-the-shipment-template': 'Somebody at the samples desk wrote in — this isn’t their automatic shipment notification.',
      'not-the-samples-desk': 'This didn’t come from the ECORE samples desk.',
      'raced-by-a-human': 'A rep saved a different tracking number while this was being processed.',
      'lead-vanished': 'The deal this matched no longer exists.',
      'tracking-belongs-on-the-quote': 'This deal\u2019s samples card lives on its quote, not on the lead \u2014 save the number there instead.',
      /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient: two boxes on one deal, and the
         email could not say which person\u2019s. Never guessed; a human picks the recipient below. */
      'ambiguous-lane': 'This deal has two recipients and the email does not say which box this is. FedEx could not tell either. Pick the recipient below.',
      'fedex-says-it-is-going-to-the-other-recipient': 'FedEx is taking this box to the OTHER recipient\u2019s city on the same deal, so the Project Name on the email is the wrong person. Pick the recipient below.'
    };

    function ecoreRowHtml(it) {
      var f = it.fields || {};
      var facts = [];
      if (f.projectName) facts.push('Project Name: <strong>' + esc(f.projectName) + '</strong>');
      if ((it.trackingNumbers || []).length) facts.push('Tracking: <strong>' + esc(it.trackingNumbers.join(', ')) + '</strong>');
      else if ((it.rejectedTracking || []).length) facts.push('Tracking (rejected): ' + esc(it.rejectedTracking.join(', ')));
      if (f.orderNumber) facts.push('Order ' + esc(f.orderNumber));
      if (f.shippedVia) facts.push(esc(f.shippedVia));
      /* Who it ALMOST matched. An ambiguous park that named neither candidate would be strictly
         less useful than the email it came from. */
      /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient: a candidate carries the lane it
         is; picking it fills the ref AND the recipient. A deferred reply is not parked yet: the worker is
         still asking FedEx where the box is going, and says so instead of a warning. */
      var _hasLane2 = it.suggestedLane === 2 || (it.candidates || []).some(function (c) { return c && c.lane === 2; });
      var cands = (it.candidates || []).map(function (c) {
        return '<button type="button" class="rqd-ecore-cand rqd-pill" data-ref="' + esc(c.ref) + '" data-lane="' + (c.lane === 2 ? '2' : '1') + '" style="font-size:10px;">'
          + esc(c.ref) + (c.customer ? ' — ' + esc(c.customer) : '') + (c.lane === 2 ? ' · 2nd recipient' : (_hasLane2 ? ' · buyer' : '')) + '</button>';
      }).join(' ');
      var num = (it.trackingNumbers || [])[0] || '';
      var _recipientSel = _hasLane2
        ? '<select class="rqd-ecore-recipient" title="Which of the deal\u2019s two recipients this box is for" style="padding:5px 6px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);">'
          + '<option value="1"' + (it.suggestedLane === 2 ? '' : ' selected') + '>Buyer</option>'
          + '<option value="2"' + (it.suggestedLane === 2 ? ' selected' : '') + '>2nd recipient</option>'
          + '</select>'
        : '';
      var _reasonLine = it.deferred
        ? '<div style="font-size:11px;color:var(--rq-text-secondary);margin:3px 0;">⏳ Waiting for FedEx to say where this box is going (the deal has two recipients). Checked again every 15 minutes; parked for a human after 24 hours.</div>'
        : '<div style="font-size:11px;color:#b45309;margin:3px 0;">⚠ ' + esc(ECORE_REASONS[it.reason] || it.reason) + '</div>';
      return '<div class="rqd-ecore-row" data-mid="' + esc(it.messageId) + '" style="border:1px solid var(--rq-border);border-radius:6px;padding:8px 10px;margin-bottom:8px;">'
        + '<div style="display:flex;justify-content:space-between;gap:8px;align-items:baseline;">'
        + '<span style="font-weight:600;font-size:12px;">' + esc(it.subject || '(no subject)') + '</span>'
        + '<span style="font-size:11px;color:var(--rq-text-secondary);white-space:nowrap;">' + esc(fmtDate(it.receivedDateTime)) + '</span>'
        + '</div>'
        + _reasonLine
        + (facts.length ? '<div style="font-size:11px;color:var(--rq-text-secondary);margin-bottom:6px;">' + facts.join(' &middot; ') + '</div>' : '')
        + (cands ? '<div style="margin-bottom:6px;display:flex;gap:4px;flex-wrap:wrap;align-items:center;"><span style="font-size:10px;color:var(--rq-text-secondary);">Did you mean</span> ' + cands + '</div>' : '')
        + '<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;">'
        + '<input type="text" class="rqd-ecore-ref" placeholder="Deal ref" value="' + esc(it.suggestedRef || '') + '" style="flex:1;min-width:120px;padding:5px 8px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);text-transform:uppercase;">'
        + '<input type="text" class="rqd-ecore-num" placeholder="Tracking #" value="' + esc(num) + '" style="flex:1;min-width:120px;padding:5px 8px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);">'
        + _recipientSel
        + '<button type="button" class="rqd-ecore-assign rqd-pill rqd-pill--active" style="font-size:11px;">Save to deal</button>'
        + '<button type="button" class="rqd-ecore-dismiss rqd-pill" style="font-size:11px;" title="Not ours to act on — remove from the queue">Dismiss</button>'
        + '<button type="button" class="rqd-ecore-body rqd-pill" style="font-size:11px;">Email</button>'
        + '<span class="rqd-ecore-row-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>'
        + '</div>'
        + '<pre class="rqd-ecore-bodytext" style="display:none;white-space:pre-wrap;font-family:inherit;font-size:11px;color:var(--rq-text-secondary);background:var(--rq-bg-input);border:1px solid var(--rq-border);border-radius:4px;padding:8px;margin:8px 0 0;max-height:200px;overflow-y:auto;">' + esc(it.body || '') + '</pre>'
        + '</div>';
    }

    function renderReplies(items) {
      if (!items.length) {
        /* ⚠️ AN EMPTY QUEUE IS GOOD NEWS AND HAS TO SAY SO, because the same emptiness is also
           what a dead reader looks like. The scan button is the only thing that tells them
           apart, so the empty state points straight at it. */
        ecoreListEl.innerHTML = '<div style="padding:10px 4px;font-size:12px;color:var(--rq-text-secondary);">No ECORE replies waiting. Tracking numbers that match a deal cleanly are saved automatically and never appear here — use “Check Abby’s inbox now” to run the reader on demand.</div>';
        return;
      }
      ecoreListEl.innerHTML = items.map(ecoreRowHtml).join('');
    }

    function loadReplies() {
      ecoreListEl.textContent = 'Loading…';
      API.get('/admin/sample-replies').then(function (res) {
        renderReplies((res && res.replies) || []);
      }).catch(function (err) {
        ecoreListEl.innerHTML = '<div style="padding:10px 4px;font-size:12px;color:#dc2626;">Could not load ECORE replies: ' + esc((err && err.message) || 'error') + '</div>';
      });
    }

    ecoreListEl.addEventListener('click', function (e) {
      var row = e.target.closest('.rqd-ecore-row');
      if (!row) return;
      var mid = row.getAttribute('data-mid');
      var statusEl = row.querySelector('.rqd-ecore-row-status');

      var cand = e.target.closest('.rqd-ecore-cand');
      if (cand) {
        row.querySelector('.rqd-ecore-ref').value = cand.getAttribute('data-ref');
        var _rs = row.querySelector('.rqd-ecore-recipient'); // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — the candidate names its lane
        if (_rs) _rs.value = cand.getAttribute('data-lane') === '2' ? '2' : '1';
        return;
      }

      if (e.target.closest('.rqd-ecore-body')) {
        var pre = row.querySelector('.rqd-ecore-bodytext');
        pre.style.display = (pre.style.display === 'none' ? 'block' : 'none');
        return;
      }

      if (e.target.closest('.rqd-ecore-assign')) {
        var ref = String((row.querySelector('.rqd-ecore-ref') || {}).value || '').trim().toUpperCase();
        var number = String((row.querySelector('.rqd-ecore-num') || {}).value || '').trim();
        if (!ref) { statusEl.style.color = '#dc2626'; statusEl.textContent = 'Enter a deal ref first.'; return; }
        if (!number) { statusEl.style.color = '#dc2626'; statusEl.textContent = 'Enter a tracking number first.'; return; }
        var aBtn = e.target.closest('.rqd-ecore-assign');
        aBtn.disabled = true; statusEl.style.color = 'var(--rq-text-secondary)'; statusEl.textContent = 'Saving…';
        var _recSel = row.querySelector('.rqd-ecore-recipient'); // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient
        var _assignBody = { messageId: mid, ref: ref, trackingNumber: number };
        if (_recSel) _assignBody.recipient = _recSel.value === '2' ? 2 : 1;
        API.post('/admin/sample-reply-assign', _assignBody).then(function (res) {
          if (!res || res.success === false || res.error) throw new Error((res && res.error) || 'Save failed');
          statusEl.style.color = '#15803d'; statusEl.textContent = '✓ saved to ' + ref + (_recSel && _recSel.value === '2' ? ' (2nd recipient)' : '');
          row.style.transition = 'opacity .2s'; row.style.opacity = '0.5';
          setTimeout(function () { row.remove(); if (!ecoreListEl.querySelector('.rqd-ecore-row')) loadReplies(); }, 1200);
        }).catch(function (err) {
          aBtn.disabled = false; statusEl.style.color = '#dc2626';
          statusEl.textContent = (err && err.message) || 'Save failed';
        });
        return;
      }

      if (e.target.closest('.rqd-ecore-dismiss')) {
        var dBtn = e.target.closest('.rqd-ecore-dismiss');
        dBtn.disabled = true; statusEl.style.color = 'var(--rq-text-secondary)'; statusEl.textContent = 'Dismissing…';
        API.post('/admin/sample-reply-dismiss', { messageId: mid }).then(function (res) {
          if (!res || res.success === false || res.error) throw new Error((res && res.error) || 'Dismiss failed');
          row.remove(); if (!ecoreListEl.querySelector('.rqd-ecore-row')) loadReplies();
        }).catch(function (err) {
          dBtn.disabled = false; statusEl.style.color = '#dc2626';
          statusEl.textContent = (err && err.message) || 'Dismiss failed';
        });
        return;
      }
    });

    /* On-demand read of Abby's mailbox. ⚠️ It reports what it DID — scanned, saved and parked,
       not just "done" — because the whole point of the button is telling a working reader apart
       from a silent one, and "0 new" is a real and useful answer rather than a failure. */
    var ecoreScanBtn = overlay.querySelector('#rqd-ecore-scan-btn');
    var ecoreScanStatus = overlay.querySelector('#rqd-ecore-scan-status');
    ecoreScanBtn.addEventListener('click', function () {
      ecoreScanBtn.disabled = true;
      ecoreScanStatus.style.color = 'var(--rq-text-secondary)';
      ecoreScanStatus.textContent = 'Reading Abby’s inbox…';
      API.get('/admin/sample-replies?scan=1').then(function (res) {
        ecoreScanBtn.disabled = false;
        var s = (res && res.scan) || {};
        if (s.error) { ecoreScanStatus.style.color = '#dc2626'; ecoreScanStatus.textContent = 'Failed: ' + s.error; }
        else {
          ecoreScanStatus.style.color = (s.written ? '#15803d' : 'var(--rq-text-secondary)');
          ecoreScanStatus.textContent = (s.scanned || 0) + ' new from ECORE · ' + (s.written || 0) + ' saved · ' + (s.parked || 0) + ' parked';
        }
        renderReplies((res && res.replies) || []);
      }).catch(function (err) {
        ecoreScanBtn.disabled = false; ecoreScanStatus.style.color = '#dc2626';
        ecoreScanStatus.textContent = 'Failed: ' + ((err && err.message) || 'error');
      });
    });

    /* ============================================
       THE GLOBAL OFF SWITCH FOR ABBY'S AUTOMATIC SAMPLES NOTICE
       ============================================
       CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20)

       ⛔ IT LIVES IN THE PORTAL BECAUSE A SWITCH THAT LIVES IN A CONFIG FILE IS A DEPLOY, AND
       A DEPLOY IS NOT A SWITCH. Ryan's PM¹⁹ rule is that an unattended customer email needs an
       off switch before it is turned on; the follow-up ladder's per-deal Stop satisfied that at
       one deal's scale, and this is the same rule at the scale of "stop everything, now".

       ⚠️ Turning it ON confirms; turning it OFF does not. Off is always the safe direction, and
       a confirm on the panic button is a confirm nobody wants at the moment they press it.

       ⚠️ The queue count is shown BEFORE the toggle is pressed, because "what will this do if I
       turn it on" is the only question worth answering here — a switch that reveals it had six
       emails waiting only after they have gone is not a switch anyone trusts twice. */
    var anBtn = overlay.querySelector('#rqd-autonotify-toggle');
    var anStatus = overlay.querySelector('#rqd-autonotify-status');
    var anGrace = overlay.querySelector('#rqd-autonotify-grace');
    var anGraceSave = overlay.querySelector('#rqd-autonotify-grace-save');
    var anState = { enabled: false, queued: 0, loaded: false };
    /* CUSTOM_SAMPLETHANKS_BY_CLAUDE - the thanks-only reply switch, painted from the same read as the switch above. */
    var tyBtn = overlay.querySelector('#rqd-thanks-toggle');
    var tyStatus = overlay.querySelector('#rqd-thanks-status');
    var tyState = { on: false, loaded: false };
    /* CUSTOM_SAMPLESERVICE_BY_CLAUDE - the Priority Overnight switch-request, painted from the same read. */
    var svBtn = overlay.querySelector('#rqd-svcask-toggle');
    var svStatus = overlay.querySelector('#rqd-svcask-status');
    var svState = { on: false, loaded: false };
    function svRender() {
      if (!svBtn) return;
      if (!svState.loaded) { svBtn.textContent = 'Checking…'; return; }
      svBtn.textContent = svState.on ? 'ON — turn off' : 'OFF — turn on';
      svBtn.style.cssText = 'font-size:11px;font-weight:700;' + (svState.on ? 'background:#14532d;color:#bbf7d0;border-color:#14532d;' : '');
      svStatus.style.color = 'var(--rq-text-secondary)';
      svStatus.textContent = 'a reply on our sample request, High importance, once per deal; the customer email waits for the new label';
    }
    function tyRender() {
      if (!tyBtn) return;
      if (!tyState.loaded) { tyBtn.textContent = 'Checking…'; return; }
      tyBtn.textContent = tyState.on ? 'ON — turn off' : 'OFF — turn on';
      tyBtn.style.cssText = 'font-size:11px;font-weight:700;' + (tyState.on ? 'background:#14532d;color:#bbf7d0;border-color:#14532d;' : '');
      tyStatus.style.color = 'var(--rq-text-secondary)';
      tyStatus.textContent = 'reply-all 15 min later (7 AM to 7 PM MT); a question or anything more goes to the agents as usual';
    }

    function anRender() {
      if (!anState.loaded) { anBtn.textContent = 'Checking…'; return; }
      anBtn.textContent = anState.enabled ? 'ON — turn off' : 'OFF — turn on';
      anBtn.style.cssText = 'font-size:11px;font-weight:700;'
        + (anState.enabled ? 'background:#14532d;color:#bbf7d0;border-color:#14532d;' : '');
      var bits = [];
      if (anState.queued) bits.push(anState.queued + ' queued');
      if (anState.stoppedCount) bits.push(anState.stoppedCount + ' deal(s) stopped');
      /* ⚠️ A queue with the switch off is a state that needs explaining, not a number to leave
         sitting there looking like pending sends. */
      if (anState.queued && !anState.enabled) bits.push('held, not discarded');
      anStatus.style.color = 'var(--rq-text-secondary)';
      anStatus.textContent = bits.join(' · ');
    }

    function anLoad() {
      API.get('/admin/samples-ladder?autonotify=1').then(function (res) {
        var cfg = (res && res.config) || {};
        anState.enabled = cfg.enabled === true;
        anState.queued = (res && res.live) || 0;
        anState.stoppedCount = (res && res.stoppedCount) || 0;
        anState.loaded = true;
        if (anGrace) anGrace.value = String(cfg.graceMinutes || 0);
        tyState.on = cfg.thanksReply === true; tyState.loaded = true; tyRender(); // CUSTOM_SAMPLETHANKS_BY_CLAUDE
        svState.on = cfg.serviceAsk === true; svState.loaded = true; svRender(); // CUSTOM_SAMPLESERVICE_BY_CLAUDE
        /* ⚠️ Rides the SAME request as the switch — they are two halves of one answer, and a
           second fetch to render one dropdown would be a second thing to fail. */
        /* ⛔ TWO SWITCHES, TWO FIELDS (2026-08-25). `audience` on this response is THIS panel's own
           channel — Abby's notice — and `sequenceAudience` is the rep-mailbox one. They were a
           single field until the split; painting either control from the wrong one would show a
           switch reporting the other switch's state, which is the exact confusion the split ended. */
        audApplyFor('notice', ((res && res.audience) || {}).audience);
        audApplyFor('sequence', ((res && res.sequenceAudience) || {}).audience);
        anRender();
      }).catch(function (err) {
        /* ⛔ Never leave the button reading "OFF" on a failed read — that is a claim about
           whether customers are being emailed, and getting it wrong in that direction is how
           somebody decides the feature is off and stops watching it. */
        anState.loaded = false;
        anBtn.textContent = 'Unavailable';
        if (tyBtn) { tyState.loaded = false; tyBtn.textContent = 'Unavailable'; } // CUSTOM_SAMPLETHANKS_BY_CLAUDE
        if (svBtn) { svState.loaded = false; svBtn.textContent = 'Unavailable'; } // CUSTOM_SAMPLESERVICE_BY_CLAUDE
        anStatus.style.color = '#dc2626';
        anStatus.textContent = 'Could not read the switch: ' + ((err && err.message) || 'error');
      });
    }

    anBtn.addEventListener('click', function () {
      if (!anState.loaded) { anLoad(); return; }
      var turningOn = !anState.enabled;
      if (turningOn && !confirm('Turn ON Abby’s automatic “your samples are on the way” email?\n\n'
        + 'From now on, every sample tracking number recorded on a deal will email that customer '
        + 'automatically, inside the 6am–6pm MT window, with nobody reviewing it.'
        + (anState.queued ? '\n\n' + anState.queued + ' notice(s) are already queued and will send.' : ''))) return;
      anBtn.disabled = true;
      anStatus.style.color = 'var(--rq-text-secondary)';
      anStatus.textContent = turningOn ? 'Turning on…' : 'Turning off…';
      API.post('/admin/samples-ladder', { enabled: turningOn }).then(function (res) {
        anBtn.disabled = false;
        if (!res || res.error) throw new Error((res && res.error) || 'failed');
        // Re-read rather than assuming the write landed the way we asked.
        anLoad();
      }).catch(function (err) {
        anBtn.disabled = false;
        anStatus.style.color = '#dc2626';
        anStatus.textContent = 'Failed: ' + ((err && err.message) || 'error');
      });
    });

    /* CUSTOM_SAMPLETHANKS_BY_CLAUDE - flip the thanks-only reply switch, then re-read rather than assume. */
    if (tyBtn) tyBtn.addEventListener('click', function () {
      if (!tyState.loaded) { anLoad(); return; }
      var turningOn = !tyState.on;
      if (turningOn && !confirm('Turn ON Abby’s “you’re welcome” reply?\n\n'
        + 'When a customer answers the samples email with nothing but thanks, Abby replies-all with one short line 15 minutes later '
        + '(7 AM to 7 PM MT). Anything with a question or new information goes to the agents as usual.')) return;
      tyBtn.disabled = true;
      tyStatus.style.color = 'var(--rq-text-secondary)';
      tyStatus.textContent = turningOn ? 'Turning on…' : 'Turning off…';
      API.post('/admin/samples-ladder', { thanksReply: turningOn }).then(function (res) {
        tyBtn.disabled = false;
        if (!res || res.error) throw new Error((res && res.error) || 'failed');
        anLoad();
      }).catch(function (err) {
        tyBtn.disabled = false;
        tyStatus.style.color = '#dc2626';
        tyStatus.textContent = 'Failed: ' + ((err && err.message) || 'error');
      });
    });

    /* CUSTOM_SAMPLESERVICE_BY_CLAUDE - flip the Priority Overnight switch-request, then re-read rather than assume. */
    if (svBtn) svBtn.addEventListener('click', function () {
      if (!svState.loaded) { anLoad(); return; }
      var turningOn = !svState.on;
      if (turningOn && !confirm('Turn ON Abby asking ECORE to switch a label to FedEx Priority Overnight?\n\n'
        + 'When a deal\'s samples were asked to ship Priority Overnight on our account and FedEx shows a different service on a label '
        + 'that has not been picked up yet, Abby replies on our sample request (High importance) asking the samples desk to switch it. '
        + 'Once per deal, no approval step.')) return;
      svBtn.disabled = true;
      svStatus.style.color = 'var(--rq-text-secondary)';
      svStatus.textContent = turningOn ? 'Turning on…' : 'Turning off…';
      API.post('/admin/samples-ladder', { serviceAsk: turningOn }).then(function (res) {
        svBtn.disabled = false;
        if (!res || res.error) throw new Error((res && res.error) || 'failed');
        anLoad();
      }).catch(function (err) {
        svBtn.disabled = false;
        svStatus.style.color = '#dc2626';
        svStatus.textContent = 'Failed: ' + ((err && err.message) || 'error');
      });
    });

    if (anGraceSave) {
      anGraceSave.addEventListener('click', function () {
        var mins = parseInt((anGrace || {}).value, 10);
        if (!isFinite(mins) || mins < 0) mins = 0;
        anGraceSave.disabled = true;
        anStatus.style.color = 'var(--rq-text-secondary)';
        anStatus.textContent = 'Saving…';
        API.post('/admin/samples-ladder', { graceMinutes: mins }).then(function (res) {
          anGraceSave.disabled = false;
          if (!res || res.error) throw new Error((res && res.error) || 'failed');
          anStatus.style.color = '#15803d';
          /* ⚠️ Says what 0 MEANS rather than echoing the number back. A grace of 0 makes the
             per-deal Cancel button technically present and practically unusable — the drain
             runs every five minutes — and that is worth knowing at the moment you set it. */
          anStatus.textContent = mins === 0
            ? '✓ sends as soon as the window is open (the per-deal Cancel has ~5 minutes)'
            : '✓ waits ' + mins + ' min, so there is time to cancel on the deal';
        }).catch(function (err) {
          anGraceSave.disabled = false;
          anStatus.style.color = '#dc2626';
          anStatus.textContent = 'Failed: ' + ((err && err.message) || 'error');
        });
      });
    }

    /* ============================================
       WHO THE AUTOMATED EMAILS RUN FOR
       ============================================
       CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20): *"right now, I ONLY want the automated from
       rep/admin emails to work for admins... Once admin has thoroughly tested and run this for a
       few weeks to find all bugs, we'll then un-gate it and turn it on for reps too."*

       ⛔ IT GOVERNS BOTH UNATTENDED SENDS — the follow-up ladder as well as the notice above —
       because Ryan drew the line around automated customer email, not around one feature. It sits
       here rather than in its own panel for the same reason the two queues share a modal: a
       second place to look is a place that stops being looked at.

       ⚠️ Widening it CONFIRMS and off-ramps first. Narrowing does not: back to admins-only is
       always the safe direction. */
    /* ============================================
       TWO SWITCHES, ONE PANEL — split on WHOSE MAILBOX SENDS (Ryan 2026-08-25)
       ============================================
       This was ONE control until the first live run of the samples chain. Ryan, reading the two
       ECORE replies that came back:

         *"I definitely still want reps customers to get emails from Abbey with tracking emails...
         I also want reps and admins to get copied onto the email when Abbey emails one of their
         customers... What I am gating from reps is once the sample is delivered, the automatic
         follow-up that comes from the reps actual email to the customer to see what they thought
         of the samples - that's the part I don't want automated for reps yet."*

       ⛔ SO THE LINE IS THE SENDING MAILBOX, NOT "IS IT AUTOMATED". Abby's notice goes out from
       orders@ and runs for everyone; the ladder and the composer sequences speak out of the rep's
       OWN mailbox and stay admin-only while they are tested.

       ⚠️ BOTH PAINT FROM THE ONE `?autonotify=1` READ that already renders the panel — `audience`
       is the notice's, `sequenceAudience` is the rep-mailbox one. Two fetches to render two
       dropdowns would be two things to fail.

       ⚠️ Widening CONFIRMS and off-ramps first. Narrowing does not: back to admins-only is always
       the safe direction, on either switch. */
    var audSel = overlay.querySelector('#rqd-audience-select');
    var audStatus = overlay.querySelector('#rqd-audience-status');
    var audCurrent = 'admins';
    var nAudSel = overlay.querySelector('#rqd-notice-audience-select');
    var nAudStatus = overlay.querySelector('#rqd-notice-audience-status');
    var nAudCurrent = 'everyone';

    /* ⛔ ONE IMPLEMENTATION, PARAMETERISED BY CHANNEL. Two hand-written copies of a control that
       mails customers is how the two drift — one gets a fix and the other keeps the bug, which is
       precisely the shape of the `titleCaseName` / `firstNameOf` split that let a mis-cased name
       reach a customer. Everything that differs between them lives in the descriptor below. */
    var CHANNELS = {
      notice: {
        sel: function () { return nAudSel; },
        status: function () { return nAudStatus; },
        get: function () { return nAudCurrent; },
        set: function (v) { nAudCurrent = v; },
        /* ⚠️ The notice DEFAULTS OPEN, so an unreadable response must not paint it as admin-only
           — that would report the feature as gated while it was in fact still emailing. */
        fallback: 'everyone',
        wide: 'every rep’s deals — every customer hears their box shipped',
        narrow: 'admin-owned deals only — a rep’s customer is told by the rep',
        confirm: 'Turn Abby’s “on the way” notice on for EVERY rep’s deals?\n\n'
          + 'When a tracking number lands, Abby emails that customer from orders@ with nobody\n'
          + 'reviewing it. The rep who owns the deal is copied on every one.',
      },
      sequence: {
        sel: function () { return audSel; },
        status: function () { return audStatus; },
        get: function () { return audCurrent; },
        set: function (v) { audCurrent = v; },
        fallback: 'admins',
        wide: 'every rep’s deals — the ladder and composer sequences send as the rep',
        narrow: 'admin-owned deals only — reps keep the bell and their own follow-ups',
        /* ⛔ THE CONFIRM ENUMERATES WHAT IT TURNS ON, AND THE COUNT MOVES WITH THE SETTING. It
           named two flows while three read the key; now Abby's notice has its own switch above, so
           it names TWO. Re-count it here whenever a flow joins or leaves this channel. */
        confirm: 'Turn the rep-mailbox automations on for EVERY rep’s deals?\n\n'
          + 'These send FROM THE REP’S OWN MAILBOX, in their name, with nobody reviewing them:\n\n'
          + '  • the four-rung samples follow-up ladder after delivery\n'
          + '  • automated follow-up sequences armed from the email composer\n\n'
          + 'Reps also stop getting the follow-up bell on any deal with a sequence running.',
      },
    };

    function audApplyFor(key, v) {
      var c = CHANNELS[key];
      var cur = (v === 'everyone' || v === 'admins') ? v : c.fallback;
      c.set(cur);
      var sel = c.sel();
      if (sel) sel.value = cur;
      /* Guarded because this is called from inside anLoad's .then: a missing element would throw
         there and surface as "Could not read the switch", blaming the wrong thing. */
      var status = c.status();
      if (!status) return;
      status.style.color = 'var(--rq-text-secondary)';
      status.textContent = cur === 'everyone' ? c.wide : c.narrow;
    }

    function wireAudience(key) {
      var c = CHANNELS[key];
      var sel = c.sel();
      if (!sel) return;
      sel.addEventListener('change', function () {
        var want = sel.value;
        if (want === c.get()) return;
        if (want === 'everyone' && !confirm(c.confirm)) {
          sel.value = c.get();   // put the control back; the change never happened
          return;
        }
        var status = c.status();
        sel.disabled = true;
        if (status) {
          status.style.color = 'var(--rq-text-secondary)';
          status.textContent = 'Saving…';
        }
        /* ⛔ THE CHANNEL IS SENT EXPLICITLY. The worker defaults an absent one to `sequence`, so
           a request that forgot it would quietly move the OTHER switch — the one that mails from a
           rep's mailbox. Never rely on that default from here. */
        API.post('/admin/samples-ladder', { audience: want, channel: key }).then(function (res) {
          sel.disabled = false;
          if (!res || res.error) throw new Error((res && res.error) || 'failed');
          audApplyFor(key, res.audience && res.audience.audience);
        }).catch(function (err) {
          sel.disabled = false;
          sel.value = c.get();
          if (status) {
            status.style.color = '#dc2626';
            status.textContent = 'Failed: ' + ((err && err.message) || 'error');
          }
        });
      });
    }

    wireAudience('notice');
    wireAudience('sequence');

    /* ============================================
       SAMPLE PICKER — "other items" (Ryan 2026-08-25)
       ============================================
       The non-Shopify half of the picker's catalog. ⛔ EDITED AS A WHOLE LIST AND SAVED IN ONE
       PUT, which is why Save is explicit rather than per-row auto-save: the worker replaces the
       array, so two rows saved independently would race and the second would drop the first.

       ⚠️ RETIRE, NOT DELETE. An item removed outright would vanish from the picker AND leave the
       deals that already list it naming something nothing explains. `active:false` stops it being
       offered while keeping it legible. Hard removal is deliberately not offered here. */
    var extrasList = overlay.querySelector('#rqd-extras-list');
    var extrasStatus = overlay.querySelector('#rqd-extras-status');
    var extras = [];

    /* ⛔ `esc` IS NOT SAFE IN AN ATTRIBUTE. It goes through textContent → innerHTML, which escapes
       `& < >` and leaves `"` untouched — fine for element text, broken inside `value="…"`. And a
       double quote is not a hypothetical here: these are SAMPLE names, where an inch mark is the
       most natural thing in the world to type (`12" spacer`, `6" swatch card`). The first such
       entry would silently truncate the input's value and inject the rest as markup. */
    function attr(s) { return esc(s).replace(/"/g, '&quot;'); }

    function extrasRender() {
      if (!extrasList) return;
      if (!extras.length) {
        extrasList.innerHTML = '<div style="font-size:12px;color:var(--rq-text-secondary);">None yet. Add one — it appears in the picker under “Other items”.</div>';
        return;
      }
      extrasList.innerHTML = extras.map(function (x, i) {
        return '<div style="display:flex;align-items:center;gap:6px;margin-bottom:5px;">'
          + '<input type="text" data-i="' + i + '" data-f="name" value="' + attr(x.name) + '" placeholder="Name"'
          + ' style="flex:0 0 220px;padding:3px 6px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);">'
          + '<input type="text" data-i="' + i + '" data-f="note" value="' + attr(x.note || '') + '" placeholder="Note (optional)"'
          + ' style="flex:1;padding:3px 6px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);">'
          + '<button type="button" class="rqd-pill" data-i="' + i + '" data-act="toggle" style="font-size:11px;">'
          + (x.active === false ? 'Retired' : 'Active') + '</button>'
          + '</div>';
      }).join('');
    }

    if (extrasList) {
      extrasList.addEventListener('input', function (e) {
        var el = e.target.closest('input[data-i]');
        if (!el) return;
        extras[Number(el.dataset.i)][el.dataset.f] = el.value;
      });
      extrasList.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-act="toggle"]');
        if (!b) return;
        var x = extras[Number(b.dataset.i)];
        x.active = x.active === false;
        extrasRender();
      });
      var addBtn = overlay.querySelector('#rqd-extras-add');
      if (addBtn) addBtn.addEventListener('click', function () {
        extras.push({ id: '', name: '', note: '', active: true });
        extrasRender();
      });
      var saveExtrasBtn = overlay.querySelector('#rqd-extras-save');
      if (saveExtrasBtn) saveExtrasBtn.addEventListener('click', function () {
        /* ⚠️ Blank rows are dropped rather than refused — an admin who clicked Add and changed
           their mind should not have to hunt for the empty row to save the others. */
        var payload = extras.filter(function (x) { return String(x.name || '').trim(); });
        saveExtrasBtn.disabled = true;
        extrasStatus.style.color = 'var(--rq-text-secondary)';
        extrasStatus.textContent = 'Saving…';
        API.post('/admin/sample-catalog', { extras: payload }).then(function (res) {
          saveExtrasBtn.disabled = false;
          if (!res || res.error) throw new Error((res && res.error) || 'failed');
          extras = res.extras || [];
          extrasRender();
          extrasStatus.textContent = 'Saved · ' + extras.filter(function (x) { return x.active !== false; }).length + ' active';
          /* The picker caches the catalog for the life of the page; without this an admin would
             save an extra here and not see it in the picker until a reload. */
          if (window.RepPortal && window.RepPortal.SamplePicker) window.RepPortal.SamplePicker.reloadCatalog();
        }).catch(function (err) {
          saveExtrasBtn.disabled = false;
          extrasStatus.style.color = '#dc2626';
          extrasStatus.textContent = 'Failed: ' + ((err && err.message) || 'error');
        });
      });

      API.get('/admin/sample-catalog').then(function (res) {
        extras = (res && res.extras) || [];
        extrasRender();
        if (res && res.fetchedAt) {
          extrasStatus.textContent = (res.products || []).length + ' ECORE products in the picker';
        }
      }).catch(function (err) {
        /* ⛔ Never render an empty editor on a failed read — it looks exactly like "no extras
           exist" and the next action would be to re-add them all, duplicating the list. */
        extrasList.innerHTML = '<div style="font-size:12px;color:#dc2626;">Could not load: '
          + esc((err && err.message) || 'error') + '</div>';
      });
    }

    anRender();
    anLoad();
    loadReplies();
    loadList();
  }
})();
